export default __webpack_public_path__ + "static/media/connect.bf1d6af3.svg";